import type { BFFArticleBodyElement } from "@src/app/types/bff";

import { mapBodyElementLayout } from "../ArticleBody";

export default function ArticleLisBulleted({
  element,
}: {
  element: BFFArticleBodyElement["list_bulleted"];
}) {
  return (
    <ul className="mb-8 ml-6 text-body-1 text-primary">
      {element.children.map((child, index) => {
        if (child.type == "list_bulleted" || child.type == "list_numbered") {
          return mapBodyElementLayout(child);
        }
        return <li key={index}>{mapBodyElementLayout(child)}</li>;
      })}
    </ul>
  );
}
